import api from './api';
import type {
  SubscriptionPlan,
  BillingOverview,
  Invoice,
  PaymentMethodItem,
  PaginatedResponse,
} from '../types';

export const billingApi = {
  getPlans() {
    return api.get<SubscriptionPlan[]>('/billing/plans/');
  },

  getOverview() {
    return api.get<BillingOverview>('/billing/overview/');
  },

  createCheckoutSession(priceId: string, billingCycle: 'monthly' | 'annual') {
    return api.post<{ checkout_url?: string; updated?: boolean }>('/billing/checkout-session/', {
      price_id: priceId,
      billing_cycle: billingCycle,
    });
  },

  createPortalSession(returnUrl?: string) {
    return api.post<{ portal_url: string }>('/billing/portal-session/', {
      return_url: returnUrl || window.location.href,
    });
  },

  getInvoices(page?: number) {
    return api.get<PaginatedResponse<Invoice>>('/billing/invoices/', {
      params: page ? { page } : undefined,
    });
  },

  getPaymentMethods() {
    return api.get<PaginatedResponse<PaymentMethodItem>>('/billing/payment-methods/');
  },

  cancelSubscription() {
    return api.post<{ detail: string }>('/billing/cancel/');
  },

  syncSubscription() {
    return api.post<{ detail: string }>('/billing/sync/');
  },

  getConfig() {
    return api.get<{ publishable_key: string }>('/billing/config/');
  },
};
